import { DataGrid, GridColumns } from "@mui/x-data-grid";
import { EditButton, List, useDataGrid } from "@refinedev/mui";
import React from "react";
import { FormControlLabel, Select } from "@mui/material";
import { useState } from "react";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { SelectChangeEvent } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { RecycleButton } from "../../components/buttons/recycle";
import { RemoveButton } from "components/buttons/remove";
import UserStatus from "@warriortrading/warriortrading.hermes.common.feathers/enums/userStatus";

export const StreamVendorsList = () => {
  const { dataGridProps, setFilters, setCurrent, setPageSize } = useDataGrid({
    sorters: {
      initial: [
        {
          field: "updatedAt",
          order: "desc",
        },
      ],
    },
    filters: {
      initial: [
        {
          field: "status",
          operator: "eq",
          value: 0,
        },
      ],
    },
    pagination: {
      pageSize: 10,
    },
  });

  const columns = React.useMemo<GridColumns<any>>(
    () => [
      {
        field: "id",
        headerName: "Id",
        type: "number",
        minWidth: 100,
        hideable: false,
      },
      {
        field: "status",
        headerName: "Status",
        minWidth: 100,
        renderCell: function render({ row }) {
          return UserStatus.fromValue(row.status)?.name;
        },
      },
      {
        field: "name",
        headerName: "Name",
        minWidth: 160,
        flex: 1,
        hideable: false,
      },
      {
        field: "showName",
        headerName: "showName",
        minWidth: 200,
        flex: 1,
        hideable: false,
      },
      {
        field: "createdAt",
        headerName: "createdAt",
        minWidth: 160,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.createdAt) {
            return new Date(row.createdAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "updatedAt",
        headerName: "UpdatedAt",
        minWidth: 160,
        hideable: false,
        renderCell: function render({ row }) {
          if (row.updatedAt) {
            return new Date(row.updatedAt).toLocaleString();
          } else {
            return "";
          }
        },
      },
      {
        field: "actions",
        headerName: "Actions",
        hideable: false,
        sortable: false,
        renderCell: function render({ row }) {
          return (
            <>
              <EditButton hideText recordItemId={row.id} />
              {row.status === 0 ? (
                <RemoveButton hideText recordItemId={row.id} />
              ) : (
                <RecycleButton hideText recordItemId={row.id} />
              )}
            </>
          );
        },
        align: "center",
        headerAlign: "center",
        minWidth: 100,
      },
    ],
    []
  );

  // search parts
  const [name, setName] = useState("");
  const [showName, setShowName] = useState("");
  const [status, setStatus] = useState<any>(0);
  const handleFilter = () => {
    setCurrent(1);
    setPageSize(10);
    let searchArr: { field: string; value: string; operator: string }[] = [];
    if (name) {
      searchArr.push({
        field: "name[$ilike]",
        value: `%${name}%`,
        operator: "eq",
      });
    }
    if (showName) {
      searchArr.push({
        field: "showName[$ilike]",
        value: `%${showName}%`,
        operator: "eq",
      });
    }
    if (status || status === 0) {
      searchArr.push({
        field: "status",
        value: `${status}`,
        operator: "eq",
      });
    }
    setFilters(searchArr as any);
  };

  const clearFun = () => {
    setName("");
    setShowName("");
    setStatus(0);
  };
  return (
    <List>
      <FormControlLabel
        label=""
        style={{ width: "100%" }}
        control={
          <div style={{ width: "100%" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
                width: "100%",
                marginLeft: "19px",
                paddingRight: "15px",
                marginBottom: "12px",
              }}
            >
              <TextField
                id="standard-basic"
                label="Name"
                variant="standard"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ width: "27%" }}
              />
              <TextField
                id="standard-basic"
                label="ShowName"
                variant="standard"
                value={showName}
                onChange={(e) => setShowName(e.target.value)}
                style={{ width: "27%" }}
              />
              <FormControl style={{ width: "27%" }}>
                <InputLabel id="status">Status : </InputLabel>
                <Select
                  labelId="status"
                  value={status as any}
                  label="Status"
                  variant="standard"
                  onChange={(event: SelectChangeEvent) => {
                    setStatus(event.target.value as any);
                  }}
                >
                  {Object.values(UserStatus)[0].map((item: any) => {
                    return (
                      <MenuItem key={item.value} value={item.value}>
                        {item.name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
              <div style={{ width: "10%", paddingBottom: "7px" }}>
                <ClearOutlinedIcon onClick={clearFun} />
                <SearchIcon onClick={handleFilter} />
              </div>
            </div>
          </div>
        }
      />
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        paginationMode="server"
        rowsPerPageOptions={[10, 20, 50]}
        disableColumnFilter
      />
    </List>
  );
};
